<template>
  <v-snackbar
    v-model="warningVisible"
    :timeout="-1"
    color="warning"
    transition="slide-y-reverse-transition"
    min-width="300"
    multi-line
    center
    bottom
    style="z-index: 9999"
  >
    <v-row align="center" align-content="center" justify="center">
      <v-icon class="ma-0 pl-4" left>
        {{ icons.mdiAlert }}
      </v-icon>
      <v-col>
        {{ storageWarning.message }}
      </v-col>
      <span id="close" color="white" style="padding: 0 12px; font-weight: 500; text-transform: uppercase" @click="dismiss">
        Close
      </span>
    </v-row>
  </v-snackbar>
</template>

<script>
import { mapState } from 'vuex'
import { recordManualDismissal } from '@/utils/storageMonitor'
import { mdiAlert } from '@mdi/js'

export default {
  data() {
    return {
      icons: { mdiAlert },
    }
  },
  computed: {
    ...mapState({
      storageWarning: state => state.notifications.storageWarning,
    }),
    warningVisible: {
      get() {
        return this.storageWarning.visible
      },
      set(value) {
        this.$store.commit('setStorageWarning', { visible: value })
      },
    },
  },
  methods: {
    dismiss() {
      this.$store.commit('setStorageWarning', { visible: false })
      recordManualDismissal()
    },
  },
}
</script>